export default "__VITE_ASSET__3d1d5587__"